import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/tools/ScreenshotImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/ui/ExpandableText.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ui/OutboundLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ui/VoteButton.tsx");
